import { baseViewWithIdSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const getOmsPriorityFilters = {
  name: "getOmsPriorityFilters" as const,
  input: z.object({}),
  output: z.object({ filters: z.array(baseViewWithIdSchema) }),
};
